import { createSelector } from 'reselect';
import { getProjectLazy } from 'src/modules/common/selectors/getProjectLazy';
import { getHvacResultsOverallRating } from 'src/modules/hvac/selectors/getHvacResultsOverallRating';
import { getProjectListItemMetrics } from 'src/modules/project-list/selectors/getProjectListItemMetrics';
import { getProjectListItemTextBlocks } from 'src/modules/project-list/selectors/getProjectListItemTextBlocks';
import { ProjectListItem } from 'src/modules/project-list/types/ProjectListItem';
import { SharedUser } from 'src/modules/sharing-projects/types/SharedUser';

export const getProjectListItem = createSelector([
  getProjectLazy,
  (state, project, members: SharedUser[]): SharedUser[] => members,
  getHvacResultsOverallRating,
  getProjectListItemTextBlocks,
  getProjectListItemMetrics,
], (project, members, rating, textBlocks, metrics): ProjectListItem => ({
  project,
  rating,
  textBlocks,
  metrics,
  members,
}));
